export const PPDCXO_CONSTANTS = {
  PPDC_UPSELL_TOUCHPOINT: 'ppdc_upsell_at_XO',
  PPDCXO_STEPUP_ENTRYPOINT: 'cardEnrolling',
  STEPUP_REQUIRED: 'STEPUP_REQUIRED',
  NO_UNIT_ID: 'NO_UNIT_ID',
  MODAL_METADATA_ID: 'PayPal Debit Card',
  ENTRY_POINT: '/myaccount/debitcards/enroll/ppdcxo',
  PRODUCT_NAME: 'CONSUMER_DEBIT_CARD',
  URL_PATH: window.location.pathname,
}
